// extracted by mini-css-extract-plugin
export default {"inputSearchContainer":"search_inputSearchContainer__bFRbo"};